import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { environment } from 'src/environments/environment';
import { SliceQuery } from '../api/api.defs';
import { InventoryRow } from './inventory.defs';
import { map } from 'rxjs/operators';
import { Inventory } from './inventory';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

	constructor(
		private _api: ApiService
	) { 

	}

	fetch() {
		return this._api
			.request<
				SliceQuery<InventoryRow>
			>({'$/slice/report': {
				slice: environment.slices.inventory,
			}}, 'inventory.fetch')
			.pipe(
				map(resp => resp.rows.map(row => new Inventory(row)))
			)
	}

	fetchServices(order: any[] = []) {
		return this._api
			.request<
				SliceQuery<InventoryRow>
			>({'$/slice/report': {
				slice: environment.slices.inventory,
				where: ['$eq', ['$field', 'TYPE'], 'SERVICE'],
				order
			}}, 'inventory.fetchServices')
			.pipe(
				map(resp => resp.rows.map(row => new Inventory(row)))
			)
	}
}
